import { createReducer } from '../../utils/misc'

import {
  FETCH_USER_PERSONAL_CCR_DATA_REQUEST,
  FETCH_USER_PERSONAL_CCR_DATA_SUCCESS,
  FETCH_USER_PERSONAL_CCR_DATA_ERROR,
  FETCH_BANK_INFORMATION_REQUEST,
  FETCH_UPDATE_BANK_INFORMATION_SUCCESS,
  FETCH_UPDATE_BANK_INFORMATION_ERROR,
  FETCH_USER_INFORMATION_REQUEST,
  FETCH_UPDATE_USER_INFORMATION_SUCCESS,
  FETCH_UPDATE_USER_INFORMATION_ERROR,
  GENERATE_USER_CCR_REQUEST,
  GENERATE_USER_CCR_SUCCESS,
  GENERATE_USER_CCR_ERROR,
  FETCH_USER_CCR_REQUEST,
  FETCH_USER_CCR_SUCCESS,
  FETCH_USER_CCR_ERROR,
  SIGN_USER_CCR_REQUEST,
  SIGN_USER_CCR_SUCCESS,
  SIGN_USER_CCR_ERROR,
  CCR_ERROR,
  FETCH_CLEAN_USER_CCR_DATA
} from '../constants/firmaCCR'

const initialState = {
  userCCR: {
    id: null,
    rut: '',
    type: '',
    email: '',
    name: '',
    lastName: '',
    serialNumber: '',
    statusCCR: '',
    address: {
      street: '',
      number: '',
      apartOrHouse: '',
      commune: '',
      city: ''
    },
    phone: '',
    bankAccount: {
      bank: '',
      type: '',
      number: ''
    }
  },
  CCR: null,
  generatingCCR: false,
  fetchingPersonalDataUserCCR: false,
  errorUserCCR: null,
  fetchingUpateBankAccount: false,
  errorUpdateBankAccount: null,
  fetchingUpateUserInfo: false,
  errorUpdateUserInfo: null,
  fetchingCCR: false,
  signingCCR: false,
  ccrError: null,
}

export default createReducer(initialState, {
  [FETCH_USER_PERSONAL_CCR_DATA_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingPersonalDataUserCCR: true,
      errorUserCCR: null,
      ccrError: null
    }),
  [FETCH_USER_PERSONAL_CCR_DATA_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      userCCR: {
        id: payload.id,
        rut: payload.rut,
        type: payload.type,
        email: payload.email,
        name: payload.firstName.split(' ')[0],
        lastName: payload.lastName1,
        serialNumber: payload.serialNumber,
        statusCCR: payload.statusCCR,
        address: payload.address
          ? {
            street: payload.address.street,
            number: String(payload.address.number),
            apartOrHouse: payload.address.apartOrHouse,
            commune: payload.address.commune,
            city: payload.address.city
          }
          : {
            street: '',
            number: '',
            apartOrHouse: '',
            commune: '',
            city: ''
          },
        phone: payload.phone,
        bankAccount: payload.bankAccount
          ? {
            bank: payload.bankAccount.bankId,
            type: payload.bankAccount.type,
            number: payload.bankAccount.number
          }
          : {
            bank: '',
            type: '',
            number: ''
          }
      },
      fetchingPersonalDataUserCCR: false,
      errorUserCCR: null,
      ccrError: null
    }),
  [FETCH_USER_PERSONAL_CCR_DATA_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingPersonalDataUserCCR: false,
      userCCR: initialState.userCCR,
      CCR: initialState.CCR,
      errorUserCCR: payload
    }),
  [FETCH_CLEAN_USER_CCR_DATA]: (state) =>
    Object.assign({}, state, {
      fetchingPersonalDataUserCCR: false,
      userCCR: initialState.userCCR,
      errorUserCCR: null
    }),
  [FETCH_BANK_INFORMATION_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingUpateBankAccount: true
    }),
  [FETCH_UPDATE_BANK_INFORMATION_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      userCCR: {
        ...state.userCCR,
        bankAccount: payload
      },
      fetchingUpateBankAccount: false,
      errorUpdateBankAccount: null
    }),
  [FETCH_UPDATE_BANK_INFORMATION_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingUpateBankAccount: false,
      errorUpdateBankAccount: payload
    }),
  [FETCH_USER_INFORMATION_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingUpateUserInfo: true
    }),
  [FETCH_UPDATE_USER_INFORMATION_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      userCCR: {
        ...state.userCCR,
        email: payload.email,
        phone: payload.phone,
        serialNumber: payload.serialNumber,
        address: payload.address
      },
      fetchingUpateUserInfo: false,
      errorUpdateUserInfo: null
    }),
  [FETCH_UPDATE_USER_INFORMATION_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingUpateUserInfo: false,
      errorUpdateUserInfo: payload
    }),
  [GENERATE_USER_CCR_REQUEST]: (state) =>
    Object.assign({}, state, {
      generatingCCR: true
    }),
  [GENERATE_USER_CCR_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      generatingCCR: false,
      CCR: payload.extras,
      userCCR: {
        ...state.userCCR,
        statusCCR: payload.solicitudCredito.statusCCR
      }
    }),
  [GENERATE_USER_CCR_ERROR]: (state) =>
    Object.assign({}, state, {
      generatingCCR: false
    }),
  [FETCH_USER_CCR_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingCCR: true
    }),
  [FETCH_USER_CCR_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingCCR: false,
      CCR: payload
    }),
  [FETCH_USER_CCR_ERROR]: (state) =>
    Object.assign({}, state, {
      fetchingCCR: false
    }),
  [SIGN_USER_CCR_REQUEST]: (state) =>
    Object.assign({}, state, {
      signingCCR: true,
      ccrError: null
    }),
  [SIGN_USER_CCR_SUCCESS]: (state) =>
    Object.assign({}, state, {
      signingCCR: false,
      ccrError: null
    }),
  [CCR_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      ccrError: payload
    }),
  [SIGN_USER_CCR_ERROR]: (state) =>
    Object.assign({}, state, {
      signingCCR: false
    }),
})
